import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private logger: LoggerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = performance.now();
    
    // Clone request to inspect it
    const method = req.method;
    const url = req.url;
    const body = req.body;
    const headers = this.getHeadersObject(req);

    // Log request
    this.logger.apiRequest(method, url, body, headers);

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const duration = performance.now() - startTime;
          this.logger.apiResponse(
            method, 
            url, 
            event.status, 
            event.body, 
            duration
          );
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const duration = performance.now() - startTime;
        
        this.logger.apiResponse(
          method, 
          url, 
          error.status, 
          {
            error: error.error,
            message: error.message
          }, 
          duration
        );

        // Re-throw the error
        return throwError(() => error);
      })
    );
  }

  private getHeadersObject(req: HttpRequest<any>): any {
    const headers: any = {};
    req.headers.keys().forEach(key => {
      headers[key] = req.headers.get(key);
    });
    return headers;
  }
}